import { CommonModule } from '@angular/common'
import { Component, Input, input, OnInit, SimpleChanges } from '@angular/core'
import { AvatarComponent, AvatarRightComponent, ProfileComponent } from '@shared/components'
import { SvgIconComponent } from 'angular-svg-icon'

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [ProfileComponent],
  templateUrl: './header.component.html',
  styleUrl: './header.component.sass',
})
export class HeaderComponent {
  logoContainer: string = 'logo-container'
  _isLoggerPage: boolean

  @Input() set isLoggerPage(value: boolean) {
    this._isLoggerPage = value
    this.logoContainer = this._isLoggerPage ? 'logger-logo-container' : 'logo-container'
  }

  get isLoggerPage(): boolean {
    return this._isLoggerPage
  }
}
